/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListStart = [
  ["path", { d: "M3 5h6" }],
  ["path", { d: "M3 12h13" }],
  ["path", { d: "M3 19h13" }],
  ["path", { d: "m16 8-3-3 3-3" }],
  ["path", { d: "M21 19V7a2 2 0 0 0-2-2h-6" }]
];

export { ListStart as default };
//# sourceMappingURL=list-start.js.map
